import IssuerListContainer from '../helpers/IssuerListContainer';

class EntercashElement extends IssuerListContainer {
    public static type = 'entercash';
}

export default EntercashElement;
